/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ArrowShapeTriangleAUpIcon16Light } from './ArrowShapeTriangleAUpIcon16Light';
import { ArrowShapeTriangleAUpIcon16Regular } from './ArrowShapeTriangleAUpIcon16Regular';
import { ArrowShapeTriangleAUpIcon16Solid } from './ArrowShapeTriangleAUpIcon16Solid';
import { ArrowShapeTriangleAUpIcon20Light } from './ArrowShapeTriangleAUpIcon20Light';
import { ArrowShapeTriangleAUpIcon20Regular } from './ArrowShapeTriangleAUpIcon20Regular';
import { ArrowShapeTriangleAUpIcon20Solid } from './ArrowShapeTriangleAUpIcon20Solid';
import { ArrowShapeTriangleAUpIcon24Regular } from './ArrowShapeTriangleAUpIcon24Regular';
import { ArrowShapeTriangleAUpIcon24Solid } from './ArrowShapeTriangleAUpIcon24Solid';
import { ArrowShapeTriangleAUpIcon32Regular } from './ArrowShapeTriangleAUpIcon32Regular';
import { ArrowShapeTriangleAUpIcon64Regular } from './ArrowShapeTriangleAUpIcon64Regular';
var sizes = {
    16: {
        light: ArrowShapeTriangleAUpIcon16Light,
        regular: ArrowShapeTriangleAUpIcon16Regular,
        solid: ArrowShapeTriangleAUpIcon16Solid,
    },
    20: {
        light: ArrowShapeTriangleAUpIcon20Light,
        regular: ArrowShapeTriangleAUpIcon20Regular,
        solid: ArrowShapeTriangleAUpIcon20Solid,
    },
    24: {
        regular: ArrowShapeTriangleAUpIcon24Regular,
        solid: ArrowShapeTriangleAUpIcon24Solid,
    },
    32: {
        regular: ArrowShapeTriangleAUpIcon32Regular,
    },
    64: {
        regular: ArrowShapeTriangleAUpIcon64Regular,
    },
};
export var ArrowShapeTriangleAUpIcon = forwardRef('ArrowShapeTriangleAUpIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
